import * as React from 'react';
import * as DetectBrowser from 'detect-browser';

import Banner from '../banner/Banner';

import { __t, applyTranslations } from 'utils/language';

import './unsupported-browser-banner.scss';

applyTranslations(require('./unsupported-browser-banner.i18n.json'));

const supportedBrowsers: Array<DetectBrowser.Browser> = [
  'chrome', 'firefox', 'safari', 'ios'
];

const MSG_KEY = 'unsupported_browser_banner';

const UnsupportedBrowserBanner = () => {
  const [isOpen, setOpen] = React.useState(true);
  const name = DetectBrowser.browserName(navigator.userAgent) as DetectBrowser.Browser;

  if (!isOpen || supportedBrowsers.includes(name)) {
    return null;
  }

  return (
    <div className="unsupported-browser-banner">
      <Banner
        background="on-white"
        onClose={() => setOpen(false)}
      >
        {__t(`${MSG_KEY}.messages.default`)}
      </Banner>
    </div>
  );
};

export default UnsupportedBrowserBanner;
